import React, { useEffect, useRef, useState } from 'react'
import './eval-data-v2.styles.scss'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUserEvalDataFromDb } from '../../../utils/getDataFromDb';

const EvalDataV2 = ({
  evalList
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const dbData = useSelector(state => state.userData.dbData);
  const [ data, setData ] = useState(null);
  const dataRef = useRef();
  const navigate = useNavigate();
  let dataListener;

  useEffect(() => {

    return () => {
      if (dataListener) dataListener();
    }
  }, [])

  useEffect(() => {
    if (!userProfile) return;
    if (!dbData.Admin) {
      navigate('/')
    }
    getRecentEvalData();
  }, [userProfile])

  function getRecentEvalData() {
    getUserEvalDataFromDb({
      'recent': true,
      'callback': callback,
      'handleListener': handleListener,
    })

    function callback(data) {
      dataRef.current = {
        ...dataRef.current,
        ...data
      }
      setData(dataRef.current)
      console.log(dataRef.current);
    }
    function handleListener(unsub) {
      dataListener = unsub;
    }
  }

  return (
    <div className='eval-data-v2'>
      EvalDataV2

    </div>
  )
}

export default EvalDataV2